import { z } from 'zod';

import { outputDatasetSchema } from '#plugin-chat/lib/tool/dataset-keys.ts';
import type { DatasetProducerResult } from '#plugin-chat/lib/tool/output-types.ts';

/**
 * Dataset registration input schema - describes what the LLM provides.
 */
export const RegisterDatasetInputSchema = z.object({
  data: z.object().array().min(1).describe('Array of objects to store as the output dataset.'),
  outputDataset: outputDatasetSchema,
  title: z.string().optional().describe('Optional description for the dataset'),
});

/**
 * @public Output type from the register dataset tool.
 *
 * Aliases the shared {@link DatasetProducerResult} contract — RegisterDatasetTool
 * stores the produced dataset envelope without adding tool-specific fields.
 */
export type RegisterDatasetOutput = DatasetProducerResult;

/** @public Input args for RegisterDatasetTool */
export type RegisterDatasetInput = z.infer<typeof RegisterDatasetInputSchema>;
